export default function MemberBidsCtrl($scope) {

}
